import { DataBean } from "../DataBean";

export class PayrollTypeWelfareType extends DataBean {

    public async getPayrollTypeWelfareTypeCatalog(idWelfareEntityType: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getPayrollTypeWelfareTypeCatalog_Number", [idWelfareEntityType]);
    }

    public async addPayrollTypeWelfareType(idPayrollType: number, idWelfareEntityType: number, accountantIDStr: string, budgetIDStr: string): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.employees.PayrollTypeWelfareType_addPayrollTypeWelfareType_Number_Number_String_String", [idPayrollType, idWelfareEntityType, accountantIDStr, budgetIDStr]);
    }

    public async deletePayrollTypeWelfareType(idPayrollTypeWelfareType: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deletePayrollTypeWelfareType_Number", [idPayrollTypeWelfareType]);
    }


}
